<template>
	<figure class="picture-img-wrapper">
		<NuxtPicture
			v-if="img && src"
			class="picture-img"
			:src="src"
			:alt="img.alt"
			:width="img.width"
			:height="img.height"
			:loading="loadingField"
			:sizes="sizesField"
			:quality="quality"
			:class="classes"
		/>
		<figcaption v-if="captionField" class="picture-img__caption">
			{{ captionField }}
		</figcaption>
	</figure>
</template>

<script setup>
const { replaceImageSrc } = useImageHelpers();
const props = defineProps({
	media: {
		type: Object,
	},
	fields: {
		type: Object,
	},
	rendering: { type: Object, required: false },
	quality: { type: String, default: undefined },
	loading: { type: String, default: "eager" },
	class: { type: String, default: "" },
	caption: { type: String, default: "" },
	sizes: { type: String, default: "xs:100vw, sm:414px, md:500px, lg:600px" },
});

const classes = computed(() => {
	return props.fields?.class?.value ? props.fields.class.value : props.class;
});

const img = computed(() => {
	if (props.media?.src) {
		return {
			src: props.media.src,
			alt: props.media.alt,
			width: props.media.width ? props.media.width : "",
			height: props.media.height ? props.media.height : "",
		};
	} else if (props.fields?.image?.value?.src) {
		return {
			src: props.fields.image.value.src,
			alt: props.fields.image.value.alt,
			width: props.fields.image.value.width
				? props.fields.image.value.width
				: "",
			height: props.fields.image.value.height
				? props.fields.image.value.height
				: "",
		};
	}
	return null;
});

const src = computed(() => {
	if (!img.value) return null;
	return replaceImageSrc(img.value?.src);
});

const loadingField = computed(() => {
	return props.fields?.loading?.value
		? props.fields.loading.value
		: props.loading;
});

const sizesField = computed(() => {
	return props.fields?.sizes?.value ? props.fields.sizes.value : props.sizes;
});

const captionField = computed(() => {
	return props.fields?.caption?.value
		? props.fields.caption.value
		: props.caption;
});
</script>

<style lang="scss">
.picture-img-wrapper {
	width: auto;
	height: auto;
	padding: 0;
	margin: 0;
}

.picture-img {
	max-width: 100%;

	img {
		max-width: 100%;
		width: 100%;
		height: auto;
		padding: var(--spacing-2, 16px);
		border-radius: 32px;
	}

	&.logo {
		display: flex;
		justify-content: center;

		img {
			margin-top: var(--spacing-2, 24px);
			max-width: 90%;
		}
	}
}

.picture-img__caption {
	padding: 0 var(--spacing-2, 16px) var(--spacing-3, 24px)
		var(--spacing-2, 16px);
	width: 100%;
	color: var(--color-grey-3, #989898);
	text-align: right;
	font-family: var(--primary-font, sans-serif);
	font-size: var(--text-sm, 14px);
	font-weight: 400;
	line-height: 128%;
}

.component--contentblock + .component--pictureimg img {
	padding-top: 0;
}

.component--pictureimg:has(+ .component--contentblock) .picture-img__caption {
	padding-bottom: 0;
}
</style>
